var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPause = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 5C10 3.89543 9.10457 3 8 3C6.89543 3 6 3.89543 6 5V19C6 20.1046 6.89543 21 8 21C9.10457 21 10 20.1046 10 19V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5C18 3.89543 17.1046 3 16 3C14.8954 3 14 3.89543 14 5V19C14 20.1046 14.8954 21 16 21C17.1046 21 18 20.1046 18 19V5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPause);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconPause.f52bda7fb4dbd0613021545583b2f8e9.svg";